import { createAsyncThunk } from '@reduxjs/toolkit';
import { getForgotPassword } from '../../api/reset-password-external-users';

export const getForgotPasswordAsync = createAsyncThunk(
  'resetPasswordExternalUsers/getForgotPassword',
  getForgotPassword
);
